export default `fragment CheckoutUserErrorFragment on CheckoutUserError {
  field
  message
  code
}`
